// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"e550aafd","691":"626b4f14"}[chunkId] + ".chunk.css";
};